<template>
  <div class="news-detail-container">
    <!-- 顶部横幅 -->
    <div class="top-banner">
      <img src="@/assets/topbanner.jpg" alt="华洲电力" class="banner-img" />
    </div>
    
    <div class="news-content-wrapper">
      <div class="news-content-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item><a href="/news">新闻资讯</a></el-breadcrumb-item>
            <el-breadcrumb-item><a href="/news">公司新闻</a></el-breadcrumb-item>
            <el-breadcrumb-item :to="`/news/${currentNews._id}`">{{ truncateTitle(currentNews.title, 20) }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        
        <el-row>
          <el-col :span="17" :offset="1">
            <!-- 新闻内容区域 -->
            <div class="news-detail-content">
              <h1 class="news-title">{{ currentNews.title }}</h1>
              <div class="news-meta">
                <span class="news-date">{{ currentNews.editTime }}</span>
                <span class="news-category">公司新闻</span>
              </div>
              
              <!-- 新闻正文 -->
              <div class="news-body" v-html="currentNews.content"></div>
              
              <!-- 上下篇导航 -->
              <div class="news-navigation">
                <div class="prev-news">
                  <span>上一篇：</span>
                  <a v-if="prevNews" :href="`/news/${prevNews._id}`">{{ prevNews.title }}</a>
                  <span v-else>没有了</span>
                </div>
                <div class="next-news">
                  <span>下一篇：</span>
                  <a v-if="nextNews" :href="`/news/${nextNews._id}`">{{ nextNews.title }}</a>
                  <span v-else>没有了</span>
                </div>
              </div>
            </div>
          </el-col>
          
          <el-col :span="5" :offset="1" :pull="0">
            <!-- 最新新闻列表 -->
            <el-card class="news-sidebar-card">
              <template #header>
                <div class="card-header">
                  <span style="font-size: 17px; font-weight: 700">最新新闻</span>
                </div>
              </template>

              <div 
                v-for="item in newstop4" 
                :key="item._id" 
                class="news-item" 
                @click="handleChangePage(item._id)"
              >
                <div class="news-item-content">
                  <span class="news-item-title">{{ truncateTitle(item.title, 40) }}</span>
                  <div class="news-item-meta">
                    <time class="news-item-date">{{ formatTime(item.editTime) }}</time>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script setup>
import { StarFilled } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { onMounted, ref, watchEffect, computed } from 'vue'
import { useHead } from '@vueuse/head'

import moment from 'moment'
moment.locale('zh-cn')

const route = useRoute()
const router = useRouter()
const currentNews = ref({})
const newstop4 = ref([])
const prevNews = ref(null) // 上一篇新闻
const nextNews = ref(null) // 下一篇新闻

// 动态SEO Meta标签配置
const meta = useHead({
  title: computed(() => `${currentNews.value.title || '新闻详情'} - 华洲电力建设有限公司`),
  meta: [
    {
      name: 'description',
      content: computed(() => {
        if (!currentNews.value.content) return '华洲电力建设有限公司新闻资讯详情'
        // 从内容中提取纯文本作为描述
        const plainText = currentNews.value.content.replace(/<[^>]+>/g, '').substring(0, 150)
        return plainText + '...'
      })
    },
    {
      name: 'keywords',
      content: '华洲电力,新闻资讯,公司新闻,行业动态'
    },
    {
      name: 'author',
      content: '华洲电力建设有限公司'
    },
    {
      property: 'og:title',
      content: computed(() => `${currentNews.value.title || '新闻详情'} - 华洲电力建设有限公司`)
    },
    {
      property: 'og:description',
      content: computed(() => {
        if (!currentNews.value.content) return '华洲电力建设有限公司新闻资讯详情'
        const plainText = currentNews.value.content.replace(/<[^>]+>/g, '').substring(0, 150)
        return plainText + '...'
      })
    },
    {
      property: 'og:type',
      content: 'article'
    }
  ]
})

// 模拟数据 - 在实际环境中会被API数据替换
const mockCurrentNews = {
  _id: '1',
  title: '华洲电力网联替我国电力行业数字化转型发展趋势分析',
  editTime: '2025-08-29',
  content: `
    <p>随着科技技术的不断发展，配电柜的市场也越来越大，对于配电柜我们也需要了解一下关于它方面的知识。配电柜它有哪些种类和作用呢？配电柜的作用是配电控制，它的工作原理是将电能分配到各个负荷部位，如果发生电路短路，过载和漏电现象就会自动断电。</p>
    <p>我们常见配电柜的种类有固定面板式配电柜、防护式配电柜、抽屉式配电柜和动力照明配电柜等。</p>
    <p>①固定面板式配电柜它的正面是柜体面板主要用来遮挡和开闭，背面和侧面设计为开放式的，可以接触到带电的器件。由于固定面板式配电柜它防护等级非常低，所以只能由于一些安全性要求不高的场合。</p>
    <div style="display: flex; gap: 20px; margin: 20px 0;">
      <img src="https://picsum.photos/500/300?random=1" alt="配电柜示例" style="width: 48%; height: auto;" />
      <img src="https://picsum.photos/500/300?random=2" alt="配电柜内部" style="width: 48%; height: auto;" />
    </div>
    <p>随着科技技术的不断发展，配电柜的市场也越来越大，对于配电柜我们也需要了解一下关于它方面的知识。配电柜它有哪些种类和作用呢？配电柜的作用是配电控制，它的工作原理是将电能分配到各个负荷部位，如果发生电路短路，过载和漏电现象就会自动断电。</p>
    <p>我们常见配电柜的种类有固定面板式配电柜、防护式配电柜、抽屉式配电柜和动力照明配电柜等。</p>
    <p>①固定面板式配电柜它的正面是柜体面板主要用来遮挡和开闭，背面和侧面设计为开放式的，可以接触到带电的器件。由于固定面板式配电柜它防护等级非常低，所以只能由于一些安全性要求不高的场合。</p>
  `
}

const mockNewstop4 = [
  {
    _id: '2',
    title: '喜报！华洲电力承建的城市新能源百万千瓦基地项目荣获2025年度中国电力优质工程奖！',
    editTime: '2025-08-20'
  },
  {
    _id: '3',
    title: '华洲电力成功入选湖南省重点扶持企业名单',
    editTime: '2025-08-15'
  },
  {
    _id: '4',
    title: '公司召开2025年上半年工作总结大会',
    editTime: '2025-08-10'
  },
  {
    _id: '5',
    title: '华洲电力与多家知名企业签署战略合作协议',
    editTime: '2025-08-05'
  }
]

watchEffect(async () => {
  if (!route.params.id) return
  
  try {
    // 尝试从API获取数据
    const res1 = await axios.get(`/webapi/news/list/${route.params.id}`)
    const res2 = await axios.get(`/webapi/news/toplist/?limit=4`)
    
    // 如果API返回了有效数据，使用API数据
    if (res1.data.data && res1.data.data.length > 0) {
      currentNews.value = res1.data.data[0]
    } else {
      // 否则使用模拟数据
      currentNews.value = mockCurrentNews
    }
    
    if (res2.data.data && res2.data.data.length > 0) {
      newstop4.value = res2.data.data
    } else {
      newstop4.value = mockNewstop4
    }
    
    // 模拟上下篇数据
    prevNews.value = mockNewstop4[0]
    nextNews.value = null
    
  } catch (error) {
    console.error('获取新闻数据失败:', error)
    // 出错时使用模拟数据
    currentNews.value = mockCurrentNews
    newstop4.value = mockNewstop4
    prevNews.value = mockNewstop4[0]
    nextNews.value = null
  }
})

// 格式化时间
const formatTime = (time) => {
  if (!time) return ''
  return moment(time).format('YYYY-MM-DD')
}

// 截断标题
const truncateTitle = (title, maxLength) => {
  if (!title) return ''
  if (title.length <= maxLength) return title
  return title.substring(0, maxLength) + '...'
}

// 切换页面
const handleChangePage = (id) => {
  router.push(`/news/${id}`)
}
</script>

<style lang="scss" scoped>
.news-detail-container {
  width: 100%;
  min-height: 100vh;
}

// 顶部横幅样式
.top-banner {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: auto;
  display: block;
}

// 内容容器
.news-content-wrapper {
  width: 100%;
  background-color: #f8f9fa;
  padding: 30px 0;
}

.news-content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// 面包屑导航
.breadcrumb-container {
  margin-bottom: 30px;
  padding: 10px 0;
}

// 主内容区域
.el-row {
  margin-top: 0;
}

// 新闻详情内容
.news-detail-content {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

// 新闻标题
.news-title {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.4;
  font-weight: 600;
}

// 新闻元信息
.news-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  color: #666;
  font-size: 0.9rem;
}

.news-date {
  color: #888;
}

.news-category {
  padding: 3px 10px;
  background-color: #f0f2f5;
  border-radius: 4px;
  color: #606266;
}

// 新闻正文
.news-body {
  color: #333;
  line-height: 1.8;
  font-size: 1rem;
  margin-bottom: 40px;
  
  p {
    margin-bottom: 15px;
    text-align: justify;
  }
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }
}

// 上下篇导航
.news-navigation {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  
  .prev-news,
  .next-news {
    margin-bottom: 15px;
    font-size: 0.95rem;
    
    a {
      color: #3f5ff0;
      text-decoration: none;
      transition: color 0.3s;
      
      &:hover {
        color: #2c3e50;
        text-decoration: underline;
      }
    }
  }
}

// 侧边栏样式
.news-sidebar-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  background-color: #3f5ff0;
  color: #fff;
  padding: 15px 20px;
  margin: -20px -20px 20px -20px;
}

.card-header span {
  color: #fff !important;
}

// 新闻列表项
.news-item {
  cursor: pointer;
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f8f9fa;
  }
}

.news-item-content {
  padding: 0;
}

.news-item-title {
  display: block;
  font-size: 0.95rem;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.5;
  transition: color 0.3s;
  
  .news-item:hover & {
    color: #3f5ff0;
  }
}

.news-item-meta {
  display: flex;
  justify-content: flex-start;
}

.news-item-date {
  font-size: 0.85rem;
  color: #999;
}

// 响应式设计
@media (max-width: 992px) {
  .news-content-container {
    padding: 0 15px;
  }
  
  .news-detail-content {
    padding: 30px 20px;
  }
  
  .news-title {
    font-size: 1.6rem;
  }
  
  .el-col {
    width: 100%;
    margin: 10px 0;
    padding: 0;
  }
}

@media (max-width: 768px) {
  .news-detail-content {
    padding: 20px 15px;
  }
  
  .news-title {
    font-size: 1.4rem;
  }
  
  .news-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .breadcrumb-container {
    margin-bottom: 20px;
  }
}
</style>
